import React from "react";
import { ChevronDown } from "lucide-react";

interface ProfileMenuButtonProps {
  avatarUrl: string;
  fallbackAvatar: string;
  isOpen: boolean;
  onClick: () => void;
}

const ProfileMenuButton: React.FC<ProfileMenuButtonProps> = ({
  avatarUrl,
  fallbackAvatar,
  isOpen,
  onClick,
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-expanded={isOpen}
    aria-label={isOpen ? "بستن منوی حساب کاربری" : "باز کردن منوی حساب کاربری"}
    title="حساب کاربری"
    className="flex h-10 items-center gap-1 rounded-xl border border-[0.6px] border-gray-400 bg-white/20 px-2.5 text-black backdrop-blur-md transition hover:bg-white/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#038545] focus-visible:ring-offset-2"
  >
    <img
      src={avatarUrl}
      alt=""
      className="h-6 w-6 rounded-full border border-white/70 object-cover"
      onError={(event) => {
        event.currentTarget.src = fallbackAvatar;
      }}
    />
    <ChevronDown
      size={14}
      aria-hidden="true"
      className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
    />
  </button>
);

export default ProfileMenuButton;
